module.exports = __webpack_public_path__ + "static/scale-model-of-roseville-california-cb3e74e9258ecd4e15896419fbbca8d5.png";